
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/eventi/[slug]",
      function () {
        return require("private-next-pages/stores/eventi/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/eventi/[slug]"])
      });
    }
  